// extracted by mini-css-extract-plugin
module.exports = {"emptyHintWrapper":"EmptyHint_emptyHintWrapper__2uLNE","tableEmptyWrapper":"EmptyHint_tableEmptyWrapper__26kbk"};